import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import MforderstatusDashboard from '../MforderstatusDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function MforderstatusPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < MforderstatusDashboard />
    )

}